import Vue from 'vue';
import './styles/base.css';
import './styles/components.css';
import App from './App.vue';

// Polyfills
import smoothscroll from 'smoothscroll-polyfill';

Vue.config.productionTip = false;

new Vue( App ).$mount( '#app' );

smoothscroll.polyfill();
